import { CherryPayApi } from "../../api/models";

export const NotificationScheduleStatuses: CherryPayApi.NotificationScheduleStatus[] =
  ["Draft", "Scheduled", "Sent", "Cancelled"];

export const NotificationSortByOptions: CherryPayApi.NotificationScheduleSortByOption[] =
  [
    "NameAsc",
    "NameDesc",
    "SendDateNewestFirst",
    "SendDateOldestFirst",
    "LastModifiedNewestFirst",
    "LastModifiedOldestFirst",
  ];

export const NotificationSortByLabels: {
  [key in CherryPayApi.NotificationScheduleSortByOption]: string;
} = {
  NameAsc: "Name (A-Z)",
  NameDesc: "Name (Z-A)",
  SendDateNewestFirst: "Send Date (Newest First)",
  SendDateOldestFirst: "Send Date (Oldest First)",
  LastModifiedNewestFirst: "Last Modified (Newest First)",
  LastModifiedOldestFirst: "Last Modified (Oldest First)",
};
